module.exports = __webpack_public_path__ + "img/1.701f4c41.png";